module.exports = __webpack_public_path__ + "media/react/assets/Progress-df5d5ebdb42e3797dfd85fa77dfe6f62.svg";